import { Navigate, Route, Routes } from "react-router-dom";
import SplashScreen from "./screens/SplashScreen";
import Plumber from "./screens/Plumber";
import AllMatchingJobs from "./screens/AllMatchingJobs";
import CurrentLoc from "./components/currentLoc";
import JobDetailsPage from "./screens/JobDetailPage";
import JobQuotesPage from "./screens/JobQuoteCalcPage";
import UploadInvoice from "./screens/UploadInvoice";
import UploadImages from "./screens/UploadImages";
import Feedback from './screens/Feedback';

import PlumberDetails from "./screens/LandingScreens/PlumberDetails";
import PlumberDetailsNext from "./screens/LandingScreens/PlumberDetailsNext";
import Setting from "./screens/Setting";
import Ratings from "./screens/Ratings";
import Login from "./screens/Login/Login";
import ManageAddress from "./screens/ManageAddress/ManageAddress";
import PaidJobs from "./screens/paidJobs"; 
import PausedJobs from "./screens/pausedJobs"; 
import InProgressJobs from "./screens/InProgressJobs"; 
import CompletedJobs from "./screens/completedJobs"; 
import CancelledAndRescheduledJobs from "./screens/cancelledAndRescheduledJobs"; 
import ViewJobDetailsFn from "./screens/JobQuoteCalcPage";
import JobDetailsFun from "./components/JobDetailComp";
import CalculationTab from "./screens/JobQuoteCalcPage/QuoteCalculationTab"; 
import ViewInvoice from "./components/viewInvoice";
import InvoicePage from "./screens/generateInvoice";
import viewDetailsFunc from "./components/JobCard";
import TopQuotes from "./screens/topQuotes";




export function AppRouter() {
  return (
    <Routes>
      {/* Update this route to navigate to /login first */}
      <Route path="/" element={<Navigate replace to="/login" />} />
      
      {/* Other routes */}
      <Route path="/index.html" element={<Navigate replace to="/login" />} />
      <Route path="/splash" element={<SplashScreen />} />
      <Route path="/plumber" element={<Plumber />} />
      <Route path="/map" element={<CurrentLoc />} />
      <Route path="/allMatchingJobs" element={<AllMatchingJobs />} />
      <Route path="/jobDetails" element={<JobDetailsPage />} />
      <Route path="/Job-quoteCal" element={<JobQuotesPage />} />
      <Route path="/uploadInvoice" element={<UploadInvoice />} />
      <Route path="/uploadImages" element={<UploadImages />} />
      <Route path="/feedback" element={<Feedback />} />
      
      <Route path="/plumberDetails" element={<PlumberDetails />} />
      <Route path="/plumberDetailsNext" element={<PlumberDetailsNext />} />
      <Route path="/setting" element={<Setting />} />
      <Route path="/ratings" element={<Ratings />} />
      <Route path="/login" element={<Login />} />
      <Route path="/ManageAddress" element={<ManageAddress/>} />
      <Route path="/PaidJobs" element={<PaidJobs />} />
      <Route path="/PausedJobs" element={<PausedJobs />} />
      <Route path="/InProgressJobs" element={<InProgressJobs />} />
      <Route path="/CompletedJobs" element={<CompletedJobs />} />
      <Route path="/CancelledAndRescheduledJobs" element={<CancelledAndRescheduledJobs />} />
      <Route path="/CancelledAndRescheduledJobs/:jobId" element={<CancelledAndRescheduledJobs />} />
      <Route path="/job-details/:jobId" element={<ViewJobDetailsFn />} />
      <Route path="/job-details/:jobId" element={<JobDetailsFun />} />
      <Route path="/quote-calculation/:jobId" element={<CalculationTab/>} />
    
      <Route path="/ViewInvoice/:jobId" element={<ViewInvoice />} />
      <Route path="/InvoicePage/:jobId" element={<InvoicePage />} />
      <Route path="/viewDetailsFunc" element={<viewDetailsFunc />} />
      <Route path="/TopQuotes" element={<TopQuotes />} />


    </Routes>
  );
}
